__turbopack_context__.v({
  "accordionSlideOverwrite": "volumeToggle-module-scss-module__Yitdca__accordionSlideOverwrite",
  "fadeIn": "volumeToggle-module-scss-module__Yitdca__fadeIn",
  "fadeOut": "volumeToggle-module-scss-module__Yitdca__fadeOut",
  "scaleIn": "volumeToggle-module-scss-module__Yitdca__scaleIn",
  "scaleOut": "volumeToggle-module-scss-module__Yitdca__scaleOut",
  "volumeToggle": "volumeToggle-module-scss-module__Yitdca__volumeToggle",
  "zoomIn": "volumeToggle-module-scss-module__Yitdca__zoomIn",
  "zoomOut": "volumeToggle-module-scss-module__Yitdca__zoomOut",
});
